/* eslint-disable */
export default {
  feedbackHeader: 'Submit Feedback',
  back: 'Back',
  revert: 'Revert',
  instruction:
    "Your feedback is valuable to us. If you have problems using the app, want to request a feature or report a bug, we're more than happy to help.",
  fillForm: 'Please fill in the form below and click ',
  useMailBox: ' or directly use your mailbox and send your request to ',
  email: 'Your email address',
  reply: '(so we can reply to you)',
  emailPlaceHolder: 'ronald.app@ringcentral.com',
  feedbackTopic: 'Feedback topic',
  topicPlaceHolder: 'Please select an option',
  bugReport: 'Bug report',
  featureRequest: 'Feature request',
  others: 'Others',
  subject: 'Subject',
  subjectPlaceHolder: 'Let us know how we can help you',
  description: 'Full description',
  descriptionPlaceHolder: 'Please include as much information as possible',
  send: 'Send your feedback',
} as const;

// @key: @#@"feedbackHeader"@#@ @source: @#@"Submit Feedback"@#@
// @key: @#@"back"@#@ @source: @#@"Back"@#@
// @key: @#@"revert"@#@ @source: @#@"Revert"@#@
// @key: @#@"instruction"@#@ @source: @#@"Your feedback is valuable for us. If you have problems using the app, want to request a feature, or report a bug, we’re more than happy to help."@#@
// @key: @#@"fillForm"@#@ @source: @#@"Please fill in the form below and click "@#@
// @key: @#@"useMailBox"@#@ @source: @#@" or directly use your mailbox and send your request to "@#@
// @key: @#@"email"@#@ @source: @#@"Your email address"@#@
// @key: @#@"reply"@#@ @source: @#@"(so we can reply to you)"@#@
// @key: @#@"emailPlaceHolder"@#@ @source: @#@"ronald.app@ringcentral.com"@#@
// @key: @#@"feedbackTopic"@#@ @source: @#@"Feedback topic"@#@
// @key: @#@"topicPlaceHolder"@#@ @source: @#@"Please select an option"@#@
// @key: @#@"bugReport"@#@ @source: @#@"Bug report"@#@
// @key: @#@"featureRequest"@#@ @source: @#@"Feature request"@#@
// @key: @#@"others"@#@ @source: @#@"Others"@#@
// @key: @#@"subject"@#@ @source: @#@"Subject"@#@
// @key: @#@"subjectPlaceHolder"@#@ @source: @#@"Let us know how we can help you"@#@
// @key: @#@"description"@#@ @source: @#@"Full description"@#@
// @key: @#@"descriptionPlaceHolder"@#@ @source: @#@"Please include as much information as possible"@#@
// @key: @#@"send"@#@ @source: @#@"Send Your Feedback"@#@
